/*
 *  -----------------------------------------------------------------------
 *    <copyright file="page-title.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import cn from 'clsx';
import React, { ReactElement } from 'react';
import './page-title.scss';

interface PageTitleProps {
    text: string;
    backButton?: ReactElement | null;
    className?: string;
}

const PageTitle = ({ text, backButton, className }: PageTitleProps) => (
    <span className={cn('page-title', className)}>
        <h1 className="title">{text}</h1>
        {backButton}
    </span>
);
export default PageTitle;
